
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './Btn_With_Img.css'

const Btn_With_Img = (props) => {
    return (
        <button 
        className={`Btn_With_Img ${props?.className}`}
        onClick={props?.onClick} type='button'>
            {props?.lottie && (
                <div className='lottie_holder'>
                    <props.lottie className="lottie_class"/>
                </div> 
            )}
            <p className='btn_text'>{props?.btn_name}</p>

        </button>
    )
}

export default Btn_With_Img
